import { Link } from "react-router-dom";
import { ntServices as mockServices } from "@/mocks/newtechData";
import { useServices } from "@/hooks/useSupabaseData";

export default function NTServicesSection() {
  const { services, loading } = useServices();

  const baseItems =
    services.length > 0
      ? services.map((s) => ({
          id: s.id,
          icon: s.icon ?? "ri-settings-line",
          title: s.name,
          subtitle: "New Tech Solution",
          desc: s.description ?? "",
        }))
      : mockServices;

  const items = [
    ...baseItems.filter(
      (s) => s.title !== "Automação Industrial"
    ),
    {
      id: 4,
      icon: "ri-refresh-line",
      title: "Retrofit e Modernização",
      subtitle: "New Tech Solution",
      desc: "Atualização tecnológica de equipamentos existentes, prolongando a vida útil e aumentando significativamente a eficiência operacional sem necessidade de substituição completa.",
      features: [
        "Diagnóstico técnico completo",
        "Substituição de componentes obsoletos",
        "Atualização de sistemas de controle",
        "Melhoria de segurança",
        "Aumento de produtividade",
      ],
      image:
        "https://readdy.ai/api/search-image?query=industrial%20machine%20retrofit%20modernization%20upgrade%20electrical%20panel%20control%20system%20engineering%20bright%20workshop%20professional&width=700&height=480&seq=ntsvc_full4&orientation=landscape",
    },
  ];

  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <p className="text-[#3FA7D6] font-bold text-sm uppercase tracking-widest mb-1">
            O que fazemos
          </p>
          <h2 className="font-rajdhani font-bold text-[#1B1F5E] text-4xl md:text-5xl">
            Nossas Soluções
          </h2>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="border border-gray-200 rounded-lg p-8 animate-pulse"
              >
                <div className="w-14 h-14 rounded-full bg-gray-100 mb-5" />
                <div className="h-5 bg-gray-100 rounded w-2/3 mb-2" />
                <div className="h-3 bg-gray-100 rounded w-full" />
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {items.map((svc) => (
              <div
                key={svc.id}
                className="border border-gray-200 rounded-lg p-8 hover:border-[#3FA7D6] transition-all group"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1B1F5E]/10 text-[#1B1F5E] mb-5 group-hover:bg-[#1B1F5E] group-hover:text-white transition-all">
                  <i className={`${svc.icon} text-2xl`}></i>
                </div>
                <h3 className="font-rajdhani font-bold text-[#1B1F5E] text-xl mb-1">
                  {svc.title}
                </h3>
                <p className="text-[#3FA7D6] text-xs font-semibold uppercase tracking-wider mb-3">
                  {svc.subtitle}
                </p>
                <p className="text-[#666] text-sm leading-relaxed">
                  {svc.desc}
                </p>
              </div>
            ))}
          </div>
        )}

        <div className="text-center mt-10">
          <Link
            to="/servicos"
            className="inline-flex items-center gap-2 border-2 border-[#1B1F5E] text-[#1B1F5E] hover:bg-[#1B1F5E] hover:text-white font-bold px-8 py-3 rounded-md transition-all cursor-pointer whitespace-nowrap text-sm"
          >
            Ver Todos os Serviços
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}